import { grey } from '@material-ui/core/colors';

export default () => ({
  selectInput: {
    padding: '18.5px 32px 18.5px 14px',
    '&:focus': { background: 'unset' },
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20,
  },
  listItem: { padding: 5 },
  listItemText: { marginRight: '20px' },
  listItemAction: {
    paddingRight: 5,
    right: 0,
  },
  statusList: {
    padding: 0,
    background: grey[50],
  },
  accordionContainer: {
    marginBottom: '1rem',
    width: '100%',
  },
  statusSendEmailIcon: { marginLeft: '1rem' },
  card: { width: '100%' },
  statusSkeletonContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem',
  },
  circleSkeleton: { marginRight: 10 },
  squareSkeleton: { margin: '0 10px' },
  flexSkeleton: { flex: 1 },
});
